var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoneBenchtops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.5,12.77 49.5,38.37 5.09,45.94 5.09,5.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.09,46.44c-0.12,0-0.23-0.04-0.32-0.12c-0.11-0.09-0.18-0.23-0.18-0.38V5.92c0-0.14,0.06-0.28,0.17-0.38 c0.11-0.09,0.26-0.14,0.4-0.11l44.41,6.84c0.24,0.04,0.42,0.25,0.42,0.49v25.61c0,0.24-0.17,0.45-0.41,0.49L5.18,46.43 C5.15,46.43,5.12,46.44,5.09,46.44z M5.59,6.5v38.85l43.41-7.4V13.19L5.59,6.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.92,
    className: "st1",
    width: 4.6,
    height: 40.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.09,46.44H0.5c-0.27,0-0.5-0.22-0.5-0.5V5.92c0-0.27,0.22-0.5,0.5-0.5h4.6c0.27,0,0.5,0.22,0.5,0.5v40.01 C5.59,46.21,5.37,46.44,5.09,46.44z M0.99,45.44h3.6V6.42h-3.6V45.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.93,47.79 18.38,49.87 10.17,44.84 17.52,43.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.96,0.13 19.35,46.74 16.75,46.74 17.14,0.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.49,7.01c-0.06,0-0.13-0.01-0.19-0.04l-2.56-1.08c-0.18-0.08-0.3-0.26-0.3-0.46V3.17 c0-0.27,0.22-0.5,0.5-0.5c0.27,0,0.5,0.22,0.5,0.5V5.1l2.25,0.95c0.25,0.11,0.37,0.4,0.26,0.65C17.86,6.9,17.68,7.01,17.49,7.01z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.82,42.9 42.37,44.68 35.37,40.38 41.64,39.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.87,4.92 43.2,42.01 40.98,42.01 41.32,4.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.61,10.87c-0.07,0-0.13-0.01-0.19-0.04L39.23,9.9c-0.18-0.08-0.3-0.26-0.3-0.46V7.51 c0-0.27,0.22-0.5,0.5-0.5c0.27,0,0.5,0.22,0.5,0.5v1.6l1.88,0.8c0.25,0.11,0.37,0.4,0.26,0.65 C41.99,10.75,41.81,10.87,41.61,10.87z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneBenchtops);
export default __webpack_public_path__ + "static/media/stone-benchtops.9100a7bf2fa1654cc200dd5455259f78.svg";
export { ForwardRef as ReactComponent };